// @flow

import { observer } from "mobx-react";
import React from "react";
import Overlay from "app/components/Overlay/Overlay";
import VideoFolderMoveStore from "app/stores/VideoFolderMoveStore";
import FolderStore from "app/stores/FolderStore";
import Video from "app/models/Video";

import "./VideoFolderMove.scss";

type Props = {
    video: Video;
};

@observer
export default class VideoFolderMove extends React.Component<Props> {
    handleCancel = () => {
        VideoFolderMoveStore.cancelEditing();
    }

    handleSelect = (e, folder) => {
        VideoFolderMoveStore.saveFolder(folder.id);
    }

    render() {
        if(!VideoFolderMoveStore.isEditing) {
            return null;
        }

        const video = this.props.video;

        return (
            <div className="VideoFolderMove">
                <Overlay active={true} onClick={this.handleCancel}/>

                <div className="VideoFolderMove__body">
                    <button
                        type="button"
                        onClick={this.handleCancel}
                        className="VideoFolderMove__cancel"
                    >
                        <i className="fa fa-remove" />
                    </button>

                    <div className="VideoFolderMove__title">
                        Move <strong>{video.title}</strong> to folder:
                    </div>
                    <div className="FolderList FolderList__modal">
                        {
                            FolderStore.folders && FolderStore.folders.length > 1
                            ? (
                                <ul>
                                    { FolderStore.folders.map((folder) => {
                                        
                                        if (folder.id === video.folder_id) return null

                                        return <li key={folder.id} className="FolderList__folder">
                                            <a onClick={(e) => this.handleSelect(e, folder)}><i className="fa fa-folder"></i> {folder.name}</a>
                                        </li>
                                    })}
                                </ul>
                            )
                            : (
                                <div className="VideoFolderMove__nofolders">
                                    No folders created. Use<br/>
                                    <strong><i className="fa fa-plus"></i>&nbsp;Add&nbsp;folder</strong><br/>
                                    on the sidebar to create your first folder.
                                </div>
                            )
                        }                        
                    </div>                    
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/VideoFolderMove/VideoFolderMove.js